import { render, staticRenderFns } from "./CustomSwiperSlide.vue?vue&type=template&id=2b01547e&"
import script from "./CustomSwiperSlide.vue?vue&type=script&lang=ts&"
export * from "./CustomSwiperSlide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports